import { createFileRoute } from "@tanstack/react-router";

import { AssetsPage } from "../assets/assets-page.tsx";
import { loadAssets } from "../assets/loaders.ts";
import { canBrowseAssets } from "../assets/permissions.ts";
import { useViewer } from "../data/hooks.ts";
import { IndexPending } from "../shell/record-pending.tsx";
import { assetsSearch, retainPropertyFilter } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !canBrowseAssets(viewer) ? <NoAccessPage /> : <AssetsPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/assets/")({
  staticData: { hasPropertyContext: true },
  validateSearch: assetsSearch,
  search: retainPropertyFilter(),
  loader: async ({ context }) => loadAssets(context.data),
  pendingComponent: () => <IndexPending />,
  component: Page,
});
